import React, { Component } from 'react'

// Components
import SaleCodeItemFields from './SaleCodeItemFields'
import Tooltip from './../../utils/Tooltip'

class SaleCodeItem extends Component {
    render() {
        const { item, index } = this.props
        const { updateLoading, updateDeleting, showButton } = item

        return (
            <tr className={'product-item' + (!!item.saved ? ' saved' : '')}>

                <SaleCodeItemFields {...this.props} />
                
                {index === 'new' ? (
                    <td className="save-cell">
                        <button className={'btn new-item-btn' + (updateLoading ? ' loading' : '')} disabled={updateLoading}
                            ref={(saveBtn) => this.saveBtn = saveBtn}
                            onClick={() => this.props.addItem()}
                        ><span>Add</span></button>
                        {!!item.errors && !!item.errors.general &&
                            <Tooltip parent={this.saveBtn} type={'dialog--error'} messageObjects={[item.errors.general]} />
                        }
                    </td>
                ) : (
                    [
                        <td className="save-cell" key={'saveCell'}>
                            <button className={'save-item-btn icon-pencil' + (updateLoading ? ' loading' : '') + (showButton ? ' show-edit-button' : '')} disabled={updateLoading || updateDeleting}
                                ref={(saveBtn) => this.saveBtn = saveBtn}
                                onClick={() => this.props.saveItem(index)}
                            ></button>
                            {!!item.errors && !!item.errors.general &&
                                <Tooltip parent={this.saveBtn} type={'dialog--error'} messageObjects={[item.errors.general]} />
                            }
                        </td>,
                        <td className="delete-cell" key={'deleteCell'}>
                            <button className={'delete-item-btn icon-cross' + (updateDeleting ? ' loading' : '')} disabled={updateLoading || updateDeleting}
                                onClick={() => this.props.deleteItem(index)}
                            ></button>
                        </td>
                    ]
                )}
            </tr>
        )
    }
}

export default SaleCodeItem



// WEBPACK FOOTER //
// ./src/components/admin/discounts/SaleCodeItem.js